export default __webpack_public_path__ + "static/media/Roboto-Medium.0fcd45fb.ttf";